import type { Partner } from "@expert/shared-types";

type FormatterType = (accountNumber: string) => string;

function formatVerizonBAN(accountNumber: string) {
    /**
     * Verizon BAN format: <vzAccountNumber>-<customerId>
     *
     * Account number is the account number in verizon
     * Customer id is basically the "line" on the account
     *
     * From Horizon/CustomerAPI: 012345678900001
     * To Verizon: 0123456789-1
     *
     * To format, we split the account number at the last 5 digits and strip off any zeroes from the account number
     */

    const splitIndex = accountNumber.length - 5;
    const customerId = accountNumber.substring(0, splitIndex);
    const vzAccountNumber = accountNumber.substring(splitIndex);

    // split off leading zeroes from accountNumber
    const strippedAccountNumber = vzAccountNumber.replace(/^0+/, "");

    return `${customerId}-${strippedAccountNumber}`;
}

export const formatAccountNumber = (accountNo: string, partner: Partner) => {
    let handler: FormatterType;

    switch (partner) {
        case "verizon":
            handler = formatVerizonBAN;
            break;
        default:
            throw new Error(`No handler for partner ${partner}`);
    }

    return handler(accountNo);
};
